<template>
  <bom-tree-chart-list ref="bomTreeChartList" class="app-container" />
</template>
<script>
import bomTreeChartList from "@/components/production/craftsmanship/bom/bomTreeChartList";
export default {
  name: 'treechartList',
  components: { bomTreeChartList },
  methods: {},
};
</script>